import { makeVar } from "@apollo/client";

export const assessmentContextSidebarVar = makeVar<{
  questionId: number;
  answerId?: number | null;
  showSuggestedResponses: boolean;
} | null>(null);
